import { render, staticRenderFns } from "./GoodsAttributeList.vue?vue&type=template&id=2fdccb63"
import script from "./GoodsAttributeList.vue?vue&type=script&lang=js"
export * from "./GoodsAttributeList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2fdccb63')) {
      api.createRecord('2fdccb63', component.options)
    } else {
      api.reload('2fdccb63', component.options)
    }
    module.hot.accept("./GoodsAttributeList.vue?vue&type=template&id=2fdccb63", function () {
      api.rerender('2fdccb63', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/center-business/goods/components/GoodsAttributeList.vue"
export default component.exports